<template>
  <CHeader fixed light>
    <button
      type="button"
      class="ml-3 d-lg-none c-header-toggler"
      v-c-emit-root-event:toggle-sidebar-mobile
    >
      <span><CIcon name="cil-menu" /></span>
    </button>
    <button
      type="button"
      class="ml-3 d-md-down-none c-header-toggler"
      v-on:click="$emit('minimize-sidebar')"
    >
      <span><CIcon name="cil-menu" /></span>
    </button>

    <CustomBreadcrumbRouter class="border-0" />

    <div class="company">
      <!-- <div v-if="user.Contact_Company_RecID">
        <CHeaderBrand
          class="mx-auto" 
          src="/img/brand/icon_orange.png"
          alt="ConstructEdge Logo"
        /> -->
      <span class="company-name">{{ user.Company_Name }}</span>
      <!-- </div> -->
    </div>

    <CHeaderNav class="mr-4">
      <CDropdown
        v-if="user.Contact_RecID != 49401"
        ref="cDropdown"
        color="secondary"
        class="m-2 request-dropdown"
      >
        <template #toggler-content>
          <span> <span>Request</span><span style="margin: 10px">|</span> </span>
        </template>
        <CDropdownItem
          :auto-close="true"
          v-if="isCcrContact"
          @click="togglePopup('showOrderModal')"
        >
          <font-awesome-icon icon="inbox" class="mb-16" />
          <span class="ml-3">Place an Order</span>
        </CDropdownItem>
        <CDropdownItem
          v-if="isCcrContact"
          @click="togglePopup('showDecommissionModal')"
        >
          <font-awesome-icon icon="tag" class="mb-16" />
          <span class="ml-3">Decommission Channels</span>
        </CDropdownItem>
        <CDropdownItem
          v-if="!isCcrCompany"
          @click="togglePopup('showOpenEventModal')"
          class="event-modal"
        >
          <icon-base
            iconName="IconAlertTriangle"
            height="15"
            width="14"
            class="mb-16 icon-alert"
          >
            <icon-AlertTriangle />
          </icon-base>
          <span class="pt-1 ml-3">Open an Event</span>
        </CDropdownItem>
        <CDropdownItem
          v-if="isRequestPlanVisible"
          :auto-close="true"
          @click="togglePopup(showRequestChannelsContainerModal())"
        >
          <icon-base
            iconName="IconTV"
            height="20"
            width="20"
            class="mb-16 television-icon"
          >
            <icon-TV />
          </icon-base>
          <span>Channel Request</span>
        </CDropdownItem>
      </CDropdown>
      <!-- <CDropdown
        color="secondary"
        class="m-2 request-dropdown"
      >
        <template #toggler-content>
          <span>Request</span><span style="margin-left:10px;margin-right:10px;">|</span> 
        </template>
        <CDropdownItem @click="showOrderModal = true">
          <font-awesome-icon icon="inbox" />
          <span>Place an Order</span>
        </CDropdownItem>
        <CDropdownItem @click="showTicketModal = true">
          <font-awesome-icon icon="tag" />
          <span>Report a Service Issue</span>
        </CDropdownItem>
      </CDropdown> -->

      <!-- <CDropdown
        id="actionsDropdown"
        placement="bottom-end"
        add-menu-classes="pt-0 margin-top"
      >
        <template #toggler>
          <div class="header-link-icons" :class="{ margin: !actionItems.length }">
            <font-awesome-icon icon="flag" />
            <CBadge v-if="actionItems.length > 0" color="danger">{{ actionItems.length }}</CBadge>
          </div>
        </template>
        <CDropdownHeader tag="div" class="text-center" color="light">
          <strong>My Actions</strong>
        </CDropdownHeader>
        <div class="scrollContainer">
          <DxDataGrid
            class="gridContainer"
            ref="actionsGrid"
            :data-source="groupedActions"
            :remote-operations="false"
            :showColumnHeaders="false"
            :hover-state-enabled="true"
            @row-click="openDashboard"
            noDataText="No Action Items"
          >
            <DxPaging
              :enabled="false"
            />
            <DxColumn
              data-field=Location_Name
              caption=""
              data-type="string"
              cell-template="cell-template"
            />
            <template #cell-template="cell">
              <div class="action-cell">
                <div class="bold">
                  {{ cell.data.data.Location_Name }}
                </div>
                <div 
                  v-for="(action, i) in cell.data.data.ActionItems" 
                  :key="`${cell.data.data.Address_RecID}${i}`" 
                  class="alert-details" 
                >
                  <div :class="`status-icon ${action.Status_Color.slice(1)}`" ></div>
                  {{ action.OrderRequestName }}: {{ action.Alert }}
                </div>
              </div>
            </template>
          </DxDataGrid>
        </div>
      </CDropdown> -->

      <!-- <CDropdown
        id="alertsDropdown"
        placement="bottom-end"
        add-menu-classes="pt-0 margin-top"
      >
        <template #toggler>
          <div class="header-link-icons" :class="{ margin: !alertItems.length }">
            <font-awesome-icon icon="bell" />
            <CBadge v-if="alertItems.length > 0" color="danger">{{ alertItems.length }}</CBadge>
          </div>
        </template>
        <CDropdownHeader tag="div" class="text-center" color="light">
          <strong>Notifications</strong>
        </CDropdownHeader>
        <div class="scrollContainer">
          <DxDataGrid
            class="gridContainer"
            ref="actionsGrid"
            :data-source="groupedAlerts"
            :remote-operations="false"
            :showColumnHeaders="false"
            :hover-state-enabled="true"
            @row-click="openDashboard"
            noDataText="No Alerts"
          >
            <DxPaging
              :enabled="false"
            />
            <DxColumn
              data-field=Location_Name
              caption=""
              data-type="string"
              cell-template="cell-template"
            />
            <template #cell-template="cell">
              <div class="action-cell">
                <div class="bold">
                  {{ cell.data.data.Location_Name }}
                </div>
                <div 
                  v-for="(action, i) in cell.data.data.ActionItems" 
                  :key="`${cell.data.data.Address_RecID}${i}`" 
                  class="alert-details"
                >
                  <span>
                    <div :class="`status-icon ${action.Status_Color.slice(1)}`" ></div>
                    {{ action.OrderRequestName }}: {{ action.Alert }}
                  </span>
                </div>
              </div>
            </template>
          </DxDataGrid>
        </div>
      </CDropdown> -->

      <div class="iconContainer">
        <!-- Removed onClick pop up and added router link to channel verification page-->
        <!--  <div class="header-link-icons"  @click="openChannelVerificationPopup()">-->
        <MyActionsDropdown
          :numberOfChannelVerification="numberOfChannelVerification"
        />

        <!--  Replaced by actions component above. To be removed post appro


         <div class="header-link-icons">  
          <router-link  :to="{path: '/home/channelVerification' }">    
            <font-awesome-icon :icon="['fas', 'flag-pennant']" style="color:#fff;font-size:18px;"           
            ></font-awesome-icon>
            <CBadge v-if="numberOfChannelVerification > 0" color="danger">{{ this.numberOfChannelVerification }}</CBadge>
          </router-link> 
       </div> -->

        <div>
          <font-awesome-icon
            :icon="['fas', 'bell']"
            style="color: #fff; font-size: 18px"
          ></font-awesome-icon>
        </div>
      </div>
      <TheHeaderDropdownAccnt
        v-bind:user="user"
        v-bind:companyList="companyList"
        id="headerdropdown"
      />
    </CHeaderNav>
    <div class="modals">
      <CModal
        id="confirmationPopup"
        title=""
        :show.sync="confirmPopupVisible"
        :centered="true"
      >
        <div>
          <div class="confirmIcon">
            <font-awesome-icon icon="square-check" />
          </div>
          <div class="confirmMessage">
            <div class="bold">{{ submissionType }} Submitted Successfully!</div>
            <div>{{ submissionType }} Number: #{{ submissionId }}</div>
          </div>
        </div>
      </CModal>

      <!-- channel verification Modal commented out since channel verification page is created 
  <div>
    <customModal
      id="channelVerificationModal"
          title="Channel Verification"
          :show.sync="isChannelVerPopupVisible"
          :centered="true"
          :backdrop="true"
          :closeOnBackdrop="false"
          width="80%"
          :CCRColoBrand="true"
        >
          <ChannelVerificationPopup 
            v-if="isChannelVerPopupVisible" 
           />
        </customModal>

      </div> -->
      <div class="modals">
        <customModal
          id="decommissionModalContainer"
          :title="placeAnOrderRequestFormTitle"
          :show.sync="showOrderModal"
          :centered="true"
          :backdrop="true"
          :closeOnBackdrop="false"
          width="1100px"
          :CCRColoBrand="true"
        >
          <PlaceAnOrderRequestForm
            v-if="showOrderModal"
            @hide-modal="showOrderModal = false"
          />
        </customModal>
      </div>
      <div class="event-modal">
        <customModal
          id="createEventID"
          :show.sync="showOpenEventModal"
          :centered="true"
          :backdrop="true"
          :closeOnBackdrop="false"
          width="560px"
          :CCRColoBrand="true"
          :hideHeaderBar="true"
        >
          <CreateEvent
            v-if="showOpenEventModal"
            @hide-modal="showOpenEventModal = false"
          />
        </customModal>
      </div>
      <div class="modals">
        <customModal
          id="decommissionModalContainer"
          :title="decommissionChannelFormTitle"
          :show.sync="showDecommissionModal"
          :centered="true"
          :backdrop="true"
          :closeOnBackdrop="false"
          width="1100px"
          :CCRColoBrand="true"
        >
          <ChannelDecommissionForm
            v-if="showDecommissionModal"
            @hide-modal="showDecommissionModal = false"
            @set-title="setDecommissionChannelFormTitle"
          />
        </customModal>
      </div>
    </div>
  </CHeader>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxPaging,
} from "devextreme-vue/data-grid";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import MyActionsDropdown from "./MyActionsDropdown";
import CustomBreadcrumbRouter from "../../components/breadcrumb/CustomBreadcrumbRouter";
import ChannelDecommissionForm from "../../views/channelsDecommissionRequest/ChannelDecommissionForm";
import PlaceAnOrderRequestForm from "../../views/placeAnOrderRequest/PlaceAnOrderRequestForm";
//import ServiceTicket from '../views/requestForms/ServiceTicket';
//import OrderForm from '../views/requestForms/orderForm/OrderForm.vue';
//import ClientOptions from '../views/requestForms/ClientOptions.vue';
//import ChannelVerificationPopup from "../../views/new_dashboard/project/ChannelVerificationPopup";
import CreateEvent from "../../views/home/openEvent/CreateEvent.vue";
import { EventBus } from "../../components/Events.js";
import IconBase from "../../components/IconBase.vue";
import IconAlertTriangle from "../../components/icons/IconAlertTriangle.vue";
import RequestChannelsContainerModal from "../../views/ChannelsRequest/RequestChannelsContainerModal.vue";
import IconTV from "../../components/icons/IconTV.vue";
export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
    CustomBreadcrumbRouter,
    //ChannelVerificationPopup,
    MyActionsDropdown,
    //ServiceTicket,
    //OrderForm,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
    //ClientOptions
    ChannelDecommissionForm,
    PlaceAnOrderRequestForm,
    IconBase,
    IconAlertTriangle,
    CreateEvent,
    RequestChannelsContainerModal,
    IconTV,
  },
  data() {
    return {
      user: this.$auth.user.UserDetails,
      selectedBU: 2, //Hardcoded to ConstructEdge
      addressRecID: null,
      siteData: {},
      companyList: [],
      selectedCompany: null,
      showOrderModal: false,
      showDecommissionModal: false,
      showTicketModal: false,
      confirmPopupVisible: false,
      showClientOptions: false,
      submissionType: null,
      submissionId: null,
      showOpenEventModal: false,
      portfolioData: [],
      isChannelVerPopupVisible: false,
      numberOfChannelVerification: [],
      decommissionChannelFormTitle: "Decommission Channel",
      placeAnOrderRequestFormTitle: "Place An Order",
    };
  },
  computed: {
    isRequestPlanVisible() {
      return this.user.RoleID == 10;
    },
    isCcrContact() {
      return this.user.Contact_Company_RecID == 2;
    },
    isCcrCompany() {
      return (
        this.user.Company_RecID == 2 && this.user.Contact_Company_RecID == 2
      );
    },
    // alertItems: function() {
    //   return this.portfolioData.filter(service => service.Status_Order > 1);
    // },
    // actionItems: function() {
    //   return this.portfolioData.filter(service => service.ActionRequiredFlag);
    // },
    groupedAlerts() {
      return this.groupItems(this.alertItems);
    },
    groupedActions() {
      return this.groupItems(this.actionItems);
    },
  },
  methods: {
    showRequestChannelsContainerModal() {
      this.$router.push({
        name: `Channel Request`,
      });
    },
    togglePopup(data) {
      this[data] = true;
      this.$refs.cDropdown.visible = false;
    },
    /* openChannelVerificationPopup(){
        this.isChannelVerPopupVisible = true;
      }, */
    setPlaceAnOrderRequestFormTitle(title) {
      this.placeAnOrderRequestFormTitle = title;
    },
    setDecommissionChannelFormTitle(title) {
      this.decommissionChannelFormTitle = title;
    },
    groupItems(items) {
      let sites = new Map();

      items?.forEach((item) => {
        if (!sites.has(item.Address_RecID)) {
          let itemObj = {
            Location_Name: item.Location_Name,
            Address_RecID: item.Address_RecID,
            ActionItems: [
              {
                OrderRequestName: item.OrderRequestName,
                Product_Name: item.Product_Name,
                Alert: item.Alert,
                Status_Color: item.Status_Color,
              },
            ],
          };

          sites.set(item.Address_RecID, itemObj);
        } else {
          let itemObj = sites.get(item.Address_RecID);
          itemObj.ActionItems.push({
            OrderRequestName: item.OrderRequestName,
            Product_Name: item.Product_Name,
            Alert: item.Alert,
            Status_Color: item.Status_Color,
          });
        }
      });

      return Array.from(sites.values());
    },
    hideModal: function () {
      this.showOrderModal = false;
      this.showTicketModal = false;
      this.showClientOptions = false;
    },
    showConfirmation(id, type) {
      console.log("Submitted", id, type);
      this.submissionId = id;
      this.submissionType = type;

      this.hideModal();
      this.confirmPopupVisible = true;
    },
    setHovered(e) {
      let eventType = e.eventType;
      let row = this.$refs["actionsGrid"].instance.getRowElement(
        e.row.rowIndex
      )[0];

      if (eventType == "mouseover") {
        row.classList.add("hovered-cell");
      }
      if (eventType == "mouseout") {
        row.classList.remove("hovered-cell");
      }
    },
    openClientOptions(e) {
      let siteData = e.data;
      console.log(siteData);
      EventBus.$emit("client-options", siteData);
    },
    /* Old logic for Actions Dropdown
      getChannelVerificationCount() {
      this.numberOfChannelVerification = null;
      let th = this;
      this.numberOfChannelVerification = [];
      axios
        .get(
          "https://api.ccr.net/ColoM360/ClientVerificationChannel_View?$count=true",
          {
            headers: {
              Authorization: `Bearer ${this.$auth.user.UserDetails.id_token}`,
              CompanyID: this.$auth.user.UserDetails.Company_RecID,
            },
          }
        )
        .then((response) => {
          let responseData = response.data.value;
          let uniquePhases = _.keys(_.countBy(responseData, function(data) { return data.ClientProjectPhaseID; }));
          let channelVerificationCountData = [];
          for(var phaseIndex = 0; phaseIndex < uniquePhases.length; phaseIndex++){
            let currentPhaseID = uniquePhases[phaseIndex];
            let currentPhaseData = responseData.filter((channels) => channels.ClientProjectPhaseID == currentPhaseID);
            let OPSCount= currentPhaseData.filter((channels) => channels.OPSApprovalNeeded == true).length;
            let ENGCount = currentPhaseData.filter((channels) => channels.ENGApprovalNeeded == true).length;
            let RejectCount = currentPhaseData.filter((channels) => channels.ChannelRejected == true).length;
            let projectName = currentPhaseData[0].ProjectName;
            if(OPSCount > 0 ){
              channelVerificationCountData.push({
                  dropdownValue: projectName + " "+"(OPS Approval: "+OPSCount+")", filterValue: "OPS", projectName: projectName});
            }
            if(ENGCount > 0 ){
              channelVerificationCountData.push({
                  dropdownValue: projectName + " "+"(ENG Approval: "+ENGCount+")", filterValue: "ENG", projectName: projectName});
            }
            if(RejectCount > 0 ){
              channelVerificationCountData.push({
                  dropdownValue: projectName + " "+"(Reject: "+RejectCount+")", filterValue: "Reject", projectName: projectName});
            }
          }
          if(response.data['@odata.count'] > 0){
            th.numberOfChannelVerification = channelVerificationCountData;
          }
        }); 
      },*/
    getChannelVerificationCount() {
      let th = this;
      let url = `https://api.ccr.net/ColoM360/ClientActions_View?$orderby=view_id`;
      this.numberOfChannelVerification = [];
      this.$axios.get(url).then((response) => {
        let responseData = response.data.value;
        let CategoryName = "";
        let dropDownViewList = [];
        let uniqueCategories = _.keys(
          _.countBy(responseData, function (data) {
            return data.CategoryID;
          })
        );
        if (uniqueCategories.length > 0) {
          for (
            var categoryIndex = 0;
            categoryIndex < uniqueCategories.length;
            uniqueCategories++
          ) {
            let currentCategory = uniqueCategories[categoryIndex];
            let categoryObjects = responseData.filter(
              (channels) => channels.CategoryID == currentCategory
            );
            CategoryName = categoryObjects[0].CategoryName;
            for (var i = 0; i < categoryObjects.length; i++) {
              if (categoryObjects[i].Value != null) {
                let jsonObj = {
                  dropDownView: categoryObjects[i].Value,
                  parameters: categoryObjects[i].Parameters,
                };
                dropDownViewList.push(jsonObj);
              }
            }
          }
          let channelVerificationCountData = [];
          for (
            var drpIndex = 0;
            drpIndex < dropDownViewList.length;
            drpIndex++
          ) {
            let dataString = dropDownViewList[drpIndex].dropDownView;
            let parameters = dropDownViewList[drpIndex].parameters.split(", ");
            channelVerificationCountData.push({
              dropdownValue: dataString,
              drpdownParameters: parameters,
            });
          }
          if (channelVerificationCountData.length > 0) {
            th.numberOfChannelVerification = [];
            let jsonObj = {
              categoryName: CategoryName,
              categoryItems: channelVerificationCountData,
            };
            th.numberOfChannelVerification.push(jsonObj);
          }
        }
      });
    },
    // openDashboard(e) {
    //   let siteId = e.data.Address_RecID;
    //   if(this.$route.path != `/dashboard/${siteId}`) {
    //     this.$router.push({ name: 'Dashboard', params: { id: siteId } });
    //   }
    // },
    async getDMAData() {
      let fltr = `?$filter=Company_RecID eq ${this.$auth.user.UserDetails.Company_RecID}`;
      let url = `https://api.ccr.net/ColoM360/ProductInstanceChannel_View${fltr}`;
      this.$axios.get(url).then((response) => {
        return response.data.value;
      });
    },
  },
  mounted: async function () {
    EventBus.$on("ticket-submitted", (id, type) => {
      this.showConfirmation(id, type);
    });
    // EventBus.$on('company-changed', async () => {
    //   this.portfolioData = await this.getDMAData();
    // })
    EventBus.$on("client-options", (siteData) => {
      this.addressRecID = siteData.Address_RecID;
      this.siteData = siteData;
      this.showClientOptions = true;
    });
    EventBus.$on("update-channel-count", async () => {
      //update count when channels are approved or rejected
      this.getChannelVerificationCount();
    });
    //this.portfolioData = await this.getLocationData();
    this.getChannelVerificationCount();
    this.selectedCompany = this.user.Company_RecID;
    this.selectedBU = 2;
    let fltr = `?$filter=(Business_Unit_RecID eq ${this.selectedBU} and  ProductCount ge 1)&$orderby= Company_Name`;
    let url = `https://api.ccr.net/ColoM360/cxp_BUClientList_view${fltr}`;

    if (this.user.Contact_Company_RecID == 2) {
      this.$axios.get(url).then((response) => {
        this.companyList = response.data.value;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
  width: 0.25rem;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(68, 68, 68, 0.26);
}

.scrollContainer:hover::-webkit-scrollbar {
  display: block;
}

.scrollContainer {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}

.gridContainer::v--deep {
  min-width: 350px;

  .dx-datagrid {
    color: #4f5d73;
  }

  .alert-details {
    margin-left: 10px;
    margin-top: 3px;
  }

  .bold {
    font-weight: bold;
  }

  .hovered-cell {
    background-color: #e6e6e6;
  }

  td {
    padding: 5px 10px;
  }
}

.action-cell {
  svg {
    margin-right: 5px;
  }
}

.status-icon {
  border: 1px solid black;
  height: 10px;
  width: 10px;
  margin-right: 5px;
  display: inline-block;
}

.B8B8B8 {
  background-color: #b8b8b8;
}

.fcff7a {
  background-color: #fcff7a;
}

.f2655e {
  background-color: #f2655e;
}

.c-header::v-deep {
  height: 58px;
  justify-content: flex-start;
  border-bottom: none;

  .margin-top {
    margin-top: 7px;
  }

  .dropdown-toggle {
    float: right;
    margin-top: 12px;
    margin-right: 25px;
  }

  .dropdown-toggle::after {
    margin-bottom: -1px;
  }

  .dropdown-item {
    span {
      margin: 3px 8px 10px 10px;
    }
    padding-top: 14px;
    padding-bottom: 0px;
  }
  .dropdown-menu {
    padding: 0px 0px 10px 0px;
  }
}

.c-header-toggler {
  margin-left: 0px !important;
  height: 57px;
  flex-grow: 0.25;

  .c-icon {
    width: 30px;
    height: 22px;
    color: #fff;
    margin: 17.5px 0px 17.5px 0px;
  }
}

.c-header-toggler:focus {
  outline: none;
}

.mr-4 {
  margin-right: 12px !important;
  height: 57px;
  flex-grow: 0.2;
  display: flex;
  justify-content: flex-end;
}

.request-dropdown {
  flex-grow: 2;
  height: 57px;
  border-right: solid thin #fff !important;

  a:active {
    background-color: gray !important;
  }
}

.marginRight25 {
  margin-right: 25px !important;
}

.header-link-icons {
  font-size: 18px;
  color: #fff;
  margin: 0px 5px 0px 10px;
  cursor: pointer;

  .badge {
    position: relative;
    font-size: 8px;
    right: 5px;
    top: 5px;
    opacity: 0.8;
  }
}
.icon-alert::v-deep {
  path {
    fill: #4f5d73 !important;
  }
}
.company {
  height: 33px;
  margin: 20px 0px auto 0px;
  flex-grow: 4;
  div {
    //width: 300px;
    margin-left: 24%;
  }

  img {
    height: 28px;
    margin-top: -16px;
  }
  .company-name {
    color: #fff;
    //margin-left: 5px;
    font-family: Helvetica, Verdana, Arial, sans-serif;
    font-size: 16px;
  }
}

.orderModal modal-content ::v--deep {
  width: none;
}

.modals::v--deep {
  #modalContainer {
    .modal-dialog.modal-dialog-centered {
      max-width: 75%;
    }
  }

  #serviceModal {
    .modal-dialog.modal-dialog-centered {
      max-width: 1050px;
    }
  }

  #clientOptionsModal {
    .modal-dialog.modal-dialog-centered {
      max-width: 1050px;
    }
  }

  .modal-content {
    border: none;

    .modal-header {
      height: 31px;
      padding: 0px;
      background-color: #222222;
      color: #fff;

      .modal-title {
        font-size: 18px;
        padding: 2px 0px 0px 8px;
        font-weight: 400;
      }

      .close {
        padding: 20px 25px 0px 0px;
        color: #fff;
        opacity: none;
      }
    }

    footer {
      display: none;
    }
  }
}

#confirmationPopup::v--deep {
  .modal-dialog.modal-dialog-centered {
    max-width: 400px;
  }

  .confirmIcon {
    width: 100px;
    margin: auto;

    svg {
      display: block;
      width: 60px;
      height: 60px;
      margin: auto;
      color: #222222;
    }
  }

  .confirmMessage {
    width: 350px;
    margin: auto;
    text-align: center;

    .bold {
      margin-top: 15px;
      margin-bottom: 5px;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
.iconContainer > div {
  display: inline-block;
  margin: 10px;
}
.header-link-icons {
  font-size: 18px;
  color: #fff;
  margin: 0px 5px 0px 10px;
  cursor: pointer;
  .badge {
    position: relative;
    font-size: 8px;
    right: 5px;
    top: 5px;
    opacity: 0.8;
  }
}
.mb-16 {
  margin-bottom: 5px;
}
.event-modal::v-deep {
  .customModal .modal-content .modal-header {
    display: none;
  }
}
.television-icon::v-deep {
  path {
    stroke: #4f5d73 !important;
  }
}
</style>
